import Icon from '../../components/Icon.vue'

Icon.register({"brands/yandex":{"width":256,"height":512,"paths":[{"d":"M153.1 315.8L65.7 512H2L98 302.2C52.9 279.3 22.8 237.8 22.8 161.1 22.7 53.7 90.8 0 171.7 0H254V512H198.9V315.8H153.1zM198.9 46.5H169.5C125.1 46.5 82.1 75.9 82.1 161.1 82.1 243.4 121.5 269.9 169.5 269.9H198.9V46.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yandex.js
// module id = JqkS
// module chunks = 0